// Single source of truth for landing-page constants.
// Update once → reflected across hero, schema.org, footer, sitemap, etc.
export const BRAND = {
    name: 'کافه رستوران آرشه',
    nameEn: 'Cafe and Restaurant ARSHE',
    tagline: 'کافه و رستوران در سهروردی شمالی',
    description: 'کافه رستوران آرشه در سهروردی شمالی، خیابان خرمشهر، با بیش از یک دهه تجربه در ارائه خدمات غذایی. ' +
        'کافه، صبحانه، ناهار و شام با غذاهای ایرانی و فرنگی — و سامانه آنلاین رزرو غذای کارمندی برای شرکت‌ها و سازمان‌ها.',
    url: 'https://arsherestaurant.com',
    domain: 'arsherestaurant.com',
    email: 'info@arsherestaurant.com',
    phone: '+982186120200',
    phoneDisplay: '۰۲۱ - ۸۶۱۲ ۰۲۰۰',
    address: 'تهران، خیابان سهروردی شمالی، خیابان خرمشهر، بین کوچه میناب و گلشن، پلاک ۹',
    city: 'تهران',
    region: 'تهران',
    country: 'IR',
    postalCode: '1557916611',
    founded: '1390', // Persian year
    openingHours: 'Mo-Fr 11:00-23:00',
    instagram: 'https://instagram.com/cafearshe',
    yearsOfExperience: 14,
};
// Hosted on Unsplash CDN (royalty-free, attribution-friendly). Each URL pins
// width=1600 + auto-format/quality so we don't ship raw 5K files. Replace any
// of these with /landing/*.jpg if/when the restaurant supplies real photos.
const UNSPLASH = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;
export const IMAGES = {
    // Hero: warm restaurant interior with overhead lighting
    heroBg: UNSPLASH('photo-1517248135467-4c7edcad34c4', 1920),
    // About: chef plating Persian food
    about: UNSPLASH('photo-1466637574441-749b8f19452f', 1400),
    gallery: [
        UNSPLASH('photo-1546069901-ba9599a7e63c'), // colorful plate
        UNSPLASH('photo-1565299624946-b28f40a0ae38'), // pizza closeup (general appetite-appeal)
        UNSPLASH('photo-1555939594-58d7cb561ad1'), // grilled chicken plate
        UNSPLASH('photo-1473093295043-cdd812d0e601'), // pasta with herbs
        UNSPLASH('photo-1504674900247-0877df9cc836'), // upscale plated dish
        UNSPLASH('photo-1414235077428-338989a2e8c0'), // cozy restaurant interior
    ],
    clients: [],
};
// Real SEO-rich anchor keywords used across the page. Keep natural; Google
// detects keyword stuffing.
export const KEYWORDS = [
    'غذای کارمندی',
    'رستوران آرشه',
    'کیترینگ شرکتی',
    'سفارش غذای کارمندی',
    'سامانه رزرو غذا',
    'منوی روزانه شرکت',
    'غذای سازمانی تهران',
    'arshe restaurant',
];
